const state = () => ({
    cache_videos: []
})

const mutations = {

    setCacheVideos(state, info) {
        state.cache_videos.push(info)
    },
    clearCacheVideo(state) {
        state.cache_videos = []
    }
}

const actions = {
    setCacheVideos({ commit }, { info }) {
        commit('setCacheVideos', info)
    },
    clearCacheVideo({ commit }) {
        commit('clearCacheVideo')
    }
}


const getters = {
    cache_videos: state => state.cache_videos
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};